import { NoteDataSource } from '@eigtech/notes-types'
import { useGetDelegateUserActiveContacts } from '@/api'
import { CohortProvider } from '@eigtech/ui-shared-api'
import { UserProvider, getUserCohort, useAuth0 } from '@eigtech/ui-shared-auth'
import { Auth0UserName } from '@eigtech/ui-shared-auth-web'
import { NotesProvider } from '@eigtech/ui-shared-notes'
import { ReactNode, useMemo } from 'react'

/**
 * Post Auth Providers are imported at the App.tsx level
 */
export function PostAuthProviders({ children }: { children: ReactNode }) {
  const { user } = useAuth0()
  const cohort = useMemo(() => getUserCohort(user) ?? 'technician', [user])

  const { contacts } = useGetDelegateUserActiveContacts()
  const metadata = useMemo(() => {
    const licenseNumber =
      contacts.find((contact) => contact.metadata.licenseNumber)?.metadata?.licenseNumber ??
      undefined

    return licenseNumber ? { licenseNumber } : undefined
  }, [contacts])

  return (
    <NotesProvider dataSource={NoteDataSource.Delegate} metadata={metadata}>
      <CohortProvider cohort={cohort}>
        <UserProvider PreferredUserComponent={Auth0UserName}>{children}</UserProvider>
      </CohortProvider>
    </NotesProvider>
  )
}
